import { MouseEventHandler, PropsWithChildren } from 'react';

import { LoadingKey } from 'utils/promise';

import { SModificationButton } from './style';

type VerificationButtonProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  loadingKey: LoadingKey;
  onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
};
export default function ModificationButton({
  onClick,
  onMouseEnter,
  loadingKey,
  children,
}: PropsWithChildren<VerificationButtonProps>) {
  return (
    <SModificationButton onClick={onClick} onMouseEnter={onMouseEnter} loadingKey={loadingKey}>
      {children}
    </SModificationButton>
  );
}
